import i18n from 'i18next';

type NamedDocumentType = { Code?: string | null; Name?: string | null };

// Seeded document types are translated by their Code; unit-specific types fall back to the stored name.
export const documentTypeName = (type: NamedDocumentType) => {
  const key = type.Code ? `entities.workerdocument.types.${type.Code}` : '';
  return key && i18n.exists(key) ? i18n.t(key) : type.Name ?? '';
};
